var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("system-custom-notifications-step", {
    attrs: { overflow: false, sidebar: false },
    scopedSlots: _vm._u([
      {
        key: "content",
        fn: function () {
          return [
            _c("div", { staticClass: "custom-notification__container" }, [
              _c("h4", { staticClass: "custom-notification__heading" }, [
                _vm._v("Build your notification"),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "custom-notification__selection" }, [
                _c("div", { staticClass: "custom-notification__option" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.stateDataNexmo,
                        expression: "stateDataNexmo",
                      },
                    ],
                    attrs: {
                      id: "option-nexmo",
                      type: "checkbox",
                      name: "nexmo",
                    },
                    domProps: {
                      checked: Array.isArray(_vm.stateDataNexmo)
                        ? _vm._i(_vm.stateDataNexmo, null) > -1
                        : _vm.stateDataNexmo,
                    },
                    on: {
                      change: function ($event) {
                        var $$a = _vm.stateDataNexmo,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = null,
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 && (_vm.stateDataNexmo = $$a.concat([$$v]))
                          } else {
                            $$i > -1 &&
                              (_vm.stateDataNexmo = $$a
                                .slice(0, $$i)
                                .concat($$a.slice($$i + 1)))
                          }
                        } else {
                          _vm.stateDataNexmo = $$c
                        }
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c("label", { attrs: { for: "option-nexmo" } }, [
                    _vm._v("SMS"),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "custom-notification__option" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.stateDataOnesignal,
                        expression: "stateDataOnesignal",
                      },
                    ],
                    attrs: {
                      id: "option-onesignal",
                      type: "checkbox",
                      name: "onesignal",
                    },
                    domProps: {
                      checked: Array.isArray(_vm.stateDataOnesignal)
                        ? _vm._i(_vm.stateDataOnesignal, null) > -1
                        : _vm.stateDataOnesignal,
                    },
                    on: {
                      change: function ($event) {
                        var $$a = _vm.stateDataOnesignal,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = null,
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 &&
                              (_vm.stateDataOnesignal = $$a.concat([$$v]))
                          } else {
                            $$i > -1 &&
                              (_vm.stateDataOnesignal = $$a
                                .slice(0, $$i)
                                .concat($$a.slice($$i + 1)))
                          }
                        } else {
                          _vm.stateDataOnesignal = $$c
                        }
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c("label", { attrs: { for: "option-onesignal" } }, [
                    _vm._v("Push Notification"),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "custom-notification__option" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.stateDataEmail,
                        expression: "stateDataEmail",
                      },
                    ],
                    attrs: {
                      id: "option-email",
                      type: "checkbox",
                      name: "email",
                    },
                    domProps: {
                      checked: Array.isArray(_vm.stateDataEmail)
                        ? _vm._i(_vm.stateDataEmail, null) > -1
                        : _vm.stateDataEmail,
                    },
                    on: {
                      change: function ($event) {
                        var $$a = _vm.stateDataEmail,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = null,
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 && (_vm.stateDataEmail = $$a.concat([$$v]))
                          } else {
                            $$i > -1 &&
                              (_vm.stateDataEmail = $$a
                                .slice(0, $$i)
                                .concat($$a.slice($$i + 1)))
                          }
                        } else {
                          _vm.stateDataEmail = $$c
                        }
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c("label", { attrs: { for: "option-email" } }, [
                    _vm._v("Email"),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              !_vm.$v.platformChosen
                ? _c("div", { staticClass: "help-block text-center" }, [
                    _vm._v("Please choose an option"),
                  ])
                : _vm._e(),
            ]),
            _vm._v(" "),
            _vm.stateDataNexmo
              ? _c("div", { staticClass: "custom-notification__form" }, [
                  _c("h2", [_vm._v("SMS Options")]),
                  _vm._v(" "),
                  _c("textarea", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.stateDataNexmoText,
                        expression: "stateDataNexmoText",
                      },
                    ],
                    ref: "nexmo_message",
                    staticClass: "form-control",
                    attrs: {
                      name: "text",
                      rows: "2",
                      maxlength: "160",
                      placeholder: "Write your message here",
                    },
                    domProps: { value: _vm.stateDataNexmoText },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.stateDataNexmoText = $event.target.value
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c("div", [
                    _c("small", [
                      _vm._v(
                        _vm._s(_vm.data.nexmo.text.length) +
                          " of 160 characters"
                      ),
                    ]),
                    _vm._v(" "),
                    !_vm.$v.stateDataNexmoText.required
                      ? _c("div", { staticClass: "help-block pull-right" }, [
                          _vm._v("Message is required"),
                        ])
                      : _vm._e(),
                  ]),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.stateDataOnesignal
              ? _c("div", { staticClass: "custom-notification__form" }, [
                  _c("h2", [_vm._v("Push Notification Options")]),
                  _vm._v(" "),
                  _c("h3", [_vm._v("Push Notification Heading")]),
                  _vm._v(" "),
                  _c("textarea", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.stateDataNotificationHeading,
                        expression: "stateDataNotificationHeading",
                      },
                    ],
                    ref: "notification_heading",
                    staticClass: "form-control",
                    attrs: {
                      name: "text",
                      rows: "2",
                      placeholder: "Write your heading here",
                    },
                    domProps: { value: _vm.stateDataNotificationHeading },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.stateDataNotificationHeading = $event.target.value
                      },
                    },
                  }),
                  _vm._v(" "),
                  !_vm.$v.stateDataNotificationHeading.required
                    ? _c("div", { staticClass: "help-block" }, [
                        _vm._v("Heading is required"),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c("h3", [_vm._v("Push Notification Content")]),
                  _vm._v(" "),
                  _c("textarea", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.stateDataNotificationContent,
                        expression: "stateDataNotificationContent",
                      },
                    ],
                    ref: "notification_heading",
                    staticClass: "form-control",
                    attrs: {
                      name: "text",
                      rows: "2",
                      placeholder: "Write your message here",
                    },
                    domProps: { value: _vm.stateDataNotificationContent },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.stateDataNotificationContent = $event.target.value
                      },
                    },
                  }),
                  _vm._v(" "),
                  !_vm.$v.stateDataNotificationContent.required
                    ? _c("div", { staticClass: "help-block" }, [
                        _vm._v("Content is required"),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("br"),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.stateDataEmail
              ? _c(
                  "div",
                  { staticClass: "custom-notification__form" },
                  [
                    _c("h2", [_vm._v("Email Options")]),
                    _vm._v(" "),
                    _c("h3", [_vm._v("Email Subject")]),
                    _vm._v(" "),
                    _c("textarea", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.stateDataEmailHeading,
                          expression: "stateDataEmailHeading",
                        },
                      ],
                      ref: "email_heading",
                      staticClass: "form-control",
                      attrs: {
                        name: "text",
                        rows: "2",
                        disabled:
                          _vm.stateDataEmailSubjectSame &&
                          _vm.stateDataOnesignal,
                        placeholder:
                          _vm.stateDataEmailSubjectSame &&
                          _vm.stateDataOnesignal
                            ? _vm.stateDataNotificationHeading
                            : "Write your heading here",
                      },
                      domProps: { value: _vm.stateDataEmailHeading },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.stateDataEmailHeading = $event.target.value
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "clearfix" }, [
                      !_vm.$v.stateDataEmailHeading.required
                        ? _c("div", { staticClass: "help-block pull-right" }, [
                            _vm._v("Subject is required"),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.stateDataOnesignal
                        ? _c(
                            "div",
                            { staticClass: "checkbox checkbox-primary" },
                            [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.stateDataEmailSubjectSame,
                                    expression: "stateDataEmailSubjectSame",
                                  },
                                ],
                                attrs: {
                                  type: "checkbox",
                                  id: `checkbox-same-subject`,
                                },
                                domProps: {
                                  value: true,
                                  checked: Array.isArray(
                                    _vm.stateDataEmailSubjectSame
                                  )
                                    ? _vm._i(
                                        _vm.stateDataEmailSubjectSame,
                                        true
                                      ) > -1
                                    : _vm.stateDataEmailSubjectSame,
                                },
                                on: {
                                  change: function ($event) {
                                    var $$a = _vm.stateDataEmailSubjectSame,
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = true,
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          (_vm.stateDataEmailSubjectSame =
                                            $$a.concat([$$v]))
                                      } else {
                                        $$i > -1 &&
                                          (_vm.stateDataEmailSubjectSame = $$a
                                            .slice(0, $$i)
                                            .concat($$a.slice($$i + 1)))
                                      }
                                    } else {
                                      _vm.stateDataEmailSubjectSame = $$c
                                    }
                                  },
                                },
                              }),
                              _vm._v(" "),
                              _c(
                                "label",
                                { attrs: { for: `checkbox-same-subject` } },
                                [_vm._v("Same as push notification?")]
                              ),
                            ]
                          )
                        : _vm._e(),
                    ]),
                    _vm._v(" "),
                    _c("h3", [_vm._v("Email Content")]),
                    _vm._v(" "),
                    _c("redactor", {
                      ref: "email_content",
                      staticClass: "form-control",
                      attrs: {
                        type: "text",
                        name: "email_content",
                        rows: "2",
                        disabled:
                          _vm.stateDataEmailContentSame &&
                          _vm.stateDataOnesignal,
                        placeholder:
                          _vm.stateDataEmailContentSame &&
                          _vm.stateDataOnesignal
                            ? _vm.stateDataNotificationContent
                            : "Write your content here",
                      },
                      model: {
                        value: _vm.stateDataEmailContent,
                        callback: function ($$v) {
                          _vm.stateDataEmailContent = $$v
                        },
                        expression: "stateDataEmailContent",
                      },
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "clearfix" }, [
                      !_vm.$v.stateDataEmailContent.required
                        ? _c("div", { staticClass: "help-block pull-right" }, [
                            _vm._v("Content is required"),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.stateDataOnesignal
                        ? _c(
                            "div",
                            { staticClass: "checkbox checkbox-primary" },
                            [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.stateDataEmailContentSame,
                                    expression: "stateDataEmailContentSame",
                                  },
                                ],
                                attrs: {
                                  type: "checkbox",
                                  id: `checkbox-same-content`,
                                },
                                domProps: {
                                  value: true,
                                  checked: Array.isArray(
                                    _vm.stateDataEmailContentSame
                                  )
                                    ? _vm._i(
                                        _vm.stateDataEmailContentSame,
                                        true
                                      ) > -1
                                    : _vm.stateDataEmailContentSame,
                                },
                                on: {
                                  change: function ($event) {
                                    var $$a = _vm.stateDataEmailContentSame,
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = true,
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          (_vm.stateDataEmailContentSame =
                                            $$a.concat([$$v]))
                                      } else {
                                        $$i > -1 &&
                                          (_vm.stateDataEmailContentSame = $$a
                                            .slice(0, $$i)
                                            .concat($$a.slice($$i + 1)))
                                      }
                                    } else {
                                      _vm.stateDataEmailContentSame = $$c
                                    }
                                  },
                                },
                              }),
                              _vm._v(" "),
                              _c(
                                "label",
                                { attrs: { for: `checkbox-same-content` } },
                                [_vm._v("Same as push notification?")]
                              ),
                            ]
                          )
                        : _vm._e(),
                    ]),
                    _vm._v(" "),
                    _c("br"),
                    _vm._v(" "),
                    _c("br"),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.stateDataOnesignal || _vm.stateDataEmail
              ? _c("div", [
                  _c("div", { staticClass: "custom-notification__container" }, [
                    _c(
                      "div",
                      { staticClass: "custom-notification__selection" },
                      [
                        _c(
                          "div",
                          { staticClass: "custom-notification__option" },
                          [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.stateDataNotificationUrl,
                                  expression: "stateDataNotificationUrl",
                                },
                              ],
                              attrs: {
                                id: "option-url",
                                type: "checkbox",
                                name: "notification_url",
                              },
                              domProps: {
                                checked: Array.isArray(
                                  _vm.stateDataNotificationUrl
                                )
                                  ? _vm._i(_vm.stateDataNotificationUrl, null) >
                                    -1
                                  : _vm.stateDataNotificationUrl,
                              },
                              on: {
                                change: function ($event) {
                                  var $$a = _vm.stateDataNotificationUrl,
                                    $$el = $event.target,
                                    $$c = $$el.checked ? true : false
                                  if (Array.isArray($$a)) {
                                    var $$v = null,
                                      $$i = _vm._i($$a, $$v)
                                    if ($$el.checked) {
                                      $$i < 0 &&
                                        (_vm.stateDataNotificationUrl =
                                          $$a.concat([$$v]))
                                    } else {
                                      $$i > -1 &&
                                        (_vm.stateDataNotificationUrl = $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1)))
                                    }
                                  } else {
                                    _vm.stateDataNotificationUrl = $$c
                                  }
                                },
                              },
                            }),
                            _vm._v(" "),
                            _c("label", { attrs: { for: "option-url" } }, [
                              _vm._v("Add URL Redirect"),
                            ]),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "custom-notification__option" },
                          [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.stateDataNotificationResponse,
                                  expression: "stateDataNotificationResponse",
                                },
                              ],
                              attrs: {
                                id: "option-response",
                                type: "checkbox",
                                name: "notification_response",
                              },
                              domProps: {
                                checked: Array.isArray(
                                  _vm.stateDataNotificationResponse
                                )
                                  ? _vm._i(
                                      _vm.stateDataNotificationResponse,
                                      null
                                    ) > -1
                                  : _vm.stateDataNotificationResponse,
                              },
                              on: {
                                change: function ($event) {
                                  var $$a = _vm.stateDataNotificationResponse,
                                    $$el = $event.target,
                                    $$c = $$el.checked ? true : false
                                  if (Array.isArray($$a)) {
                                    var $$v = null,
                                      $$i = _vm._i($$a, $$v)
                                    if ($$el.checked) {
                                      $$i < 0 &&
                                        (_vm.stateDataNotificationResponse =
                                          $$a.concat([$$v]))
                                    } else {
                                      $$i > -1 &&
                                        (_vm.stateDataNotificationResponse = $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1)))
                                    }
                                  } else {
                                    _vm.stateDataNotificationResponse = $$c
                                  }
                                },
                              },
                            }),
                            _vm._v(" "),
                            _c("label", { attrs: { for: "option-response" } }, [
                              _vm._v("Collect Responses"),
                            ]),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "custom-notification__option" },
                          [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.stateDataNotificationPackage,
                                  expression: "stateDataNotificationPackage",
                                },
                              ],
                              attrs: {
                                id: "option-package",
                                type: "checkbox",
                                name: "notification_package",
                              },
                              domProps: {
                                checked: Array.isArray(
                                  _vm.stateDataNotificationPackage
                                )
                                  ? _vm._i(
                                      _vm.stateDataNotificationPackage,
                                      null
                                    ) > -1
                                  : _vm.stateDataNotificationPackage,
                              },
                              on: {
                                change: function ($event) {
                                  var $$a = _vm.stateDataNotificationPackage,
                                    $$el = $event.target,
                                    $$c = $$el.checked ? true : false
                                  if (Array.isArray($$a)) {
                                    var $$v = null,
                                      $$i = _vm._i($$a, $$v)
                                    if ($$el.checked) {
                                      $$i < 0 &&
                                        (_vm.stateDataNotificationPackage =
                                          $$a.concat([$$v]))
                                    } else {
                                      $$i > -1 &&
                                        (_vm.stateDataNotificationPackage = $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1)))
                                    }
                                  } else {
                                    _vm.stateDataNotificationPackage = $$c
                                  }
                                },
                              },
                            }),
                            _vm._v(" "),
                            _c("label", { attrs: { for: "option-package" } }, [
                              _vm._v("Package Notification"),
                            ]),
                          ]
                        ),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c("div", { staticClass: "custom-notification__form" }, [
                    _vm.data.settings.package_notification
                      ? _c(
                          "div",
                          [
                            _c("h3", [_vm._v("Selected Package")]),
                            _vm._v(" "),
                            _c("selectize", {
                              staticClass:
                                "selectize selectize-single form-control",
                              attrs: {
                                name: "tag_type",
                                options: _vm.packageList,
                                "disable-delete": true,
                              },
                              model: {
                                value: _vm.stateDataNotificationSelectedPackage,
                                callback: function ($$v) {
                                  _vm.stateDataNotificationSelectedPackage = $$v
                                },
                                expression:
                                  "stateDataNotificationSelectedPackage",
                              },
                            }),
                            _vm._v(" "),
                            !_vm.$v.stateDataNotificationSelectedPackage
                              .required
                              ? _c("div", { staticClass: "help-block" }, [
                                  _vm._v("Package is required"),
                                ])
                              : _vm._e(),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.data.settings.link_notification
                      ? _c("div", [
                          _c("h3", [_vm._v("Push Notification Link")]),
                          _vm._v(" "),
                          _c("textarea", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.stateDataNotificationLink,
                                expression: "stateDataNotificationLink",
                              },
                            ],
                            ref: "notification_heading",
                            staticClass: "form-control",
                            attrs: {
                              name: "text",
                              rows: "2",
                              placeholder:
                                "Write your link here, use {talent_id} or {talent_slug} to add a talent id or name to the link",
                            },
                            domProps: { value: _vm.stateDataNotificationLink },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.stateDataNotificationLink =
                                  $event.target.value
                              },
                            },
                          }),
                          _vm._v(" "),
                          !_vm.$v.stateDataNotificationLink.required
                            ? _c(
                                "div",
                                { staticClass: "help-block pull-right" },
                                [_vm._v("Link is required")]
                              )
                            : _vm._e(),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.data.settings.response_notification
                      ? _c("div", [
                          _c("h2", [
                            _vm._v(
                              "\n            Action Buttons\n            "
                            ),
                            _c(
                              "a",
                              {
                                class: _vm.checkCanAddAction,
                                attrs: { "data-backdrop": "static" },
                                on: { click: _vm.addActionButton },
                              },
                              [
                                _c("i", { staticClass: "fa fa-plus" }),
                                _vm._v(" "),
                                [_vm._v("Add Button")],
                              ],
                              2
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "description" }, [
                            _vm._v(
                              " Note: A dismiss/cancel button saying 'Sorry, Not Interested' gets automatically\n            added to the notification and doesn't need to be added.\n          "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "dashboard-block" },
                            [
                              _vm._l(
                                _vm.data.settings.button_items,
                                function (suboption, index) {
                                  return _c(
                                    "ul",
                                    { key: index, staticClass: "item-detail" },
                                    [
                                      _c(
                                        "system-custom-notifications-response-list-item",
                                        {
                                          attrs: {
                                            index: index,
                                            "extra-field": index > 0,
                                            validation:
                                              _vm.$v.stateDataButtonItems.$each[
                                                index
                                              ],
                                          },
                                        }
                                      ),
                                    ],
                                    1
                                  )
                                }
                              ),
                              _vm._v(" "),
                              _c("div", { attrs: { id: "bottom" } }),
                            ],
                            2
                          ),
                        ])
                      : _vm._e(),
                  ]),
                ])
              : _vm._e(),
          ]
        },
        proxy: true,
      },
      {
        key: "cta",
        fn: function () {
          return [
            _c(
              "button",
              {
                staticClass: "btn btn-primary pull-right",
                attrs: { type: "button", disabled: _vm.$v.$invalid },
                on: {
                  submit: function ($event) {
                    $event.preventDefault()
                  },
                  click: _vm.nextPage,
                },
              },
              [
                _vm._v("Continue "),
                _c("i", { staticClass: "fa fa-chevron-right" }),
              ]
            ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }